import {Pagination} from '@app/core/models/pagination.model';
import {BulletinBoardPost} from '@app/core/models/bulletinBoardPost.model';
import {Group} from '@app/core/models/group.model';
import {BulletinBoardPostComment} from '@app/core/models/bulletinBoardPostComment.model';
import {User} from '@app/core/models/user.model';
import {BulletinBoardPostLike} from '@app/core/models/bulletinBoardPostLike.model';

export interface IBulletinBoardState {
	pagination: Pagination;
	bulletinPosts: BulletinBoardPost[];
	postToEdit: BulletinBoardPost;
	groups: Group[];
	isLoading: boolean;
	comments: BulletinBoardPostComment[];
	commentsPagination: Pagination;
	selectedPostIdForComments: number;
	postSeenByInfo: User[];
	postLikedByInfo: BulletinBoardPostLike[];
	postLikedByInfoPagination: Pagination;
	isLoadingInfo: boolean;
}

export const initialBulletinBoardState: IBulletinBoardState = {
	bulletinPosts: [],
	comments: [],
	postToEdit: undefined,
	pagination: undefined,
	groups: [],
	isLoading: false,
	commentsPagination: undefined,
	selectedPostIdForComments: undefined,
	postSeenByInfo: [],
	postLikedByInfo: [],
	postLikedByInfoPagination: undefined,
	isLoadingInfo: false,
};
